export default "__VITE_ASSET__n4AOVpck__"